import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Country, CountryService, Profile, UserService } from 'octali-lib-firebase-utils';
import { Address, AddressService } from 'octali-lib-shop';
import { LoggerService, DisplayerService } from 'octali-lib-utils';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-address',
  templateUrl: './address.page.html',
  styleUrls: ['./address.page.scss'],
})
export class AddressPage implements OnInit {

  public addressForm: FormGroup;
  private address: Address;
  public countries: Array<Country> = [];
  private mapCountries : Map<string,Country> = new Map<string,Country>();
  private profile:Profile;

  descending: boolean = true;
  order: number = 1;
  column: string = 'name';
  
  constructor(
    private formBuilder: FormBuilder,
    private addressService: AddressService,
    private countryService: CountryService,
    private logger: LoggerService,
    private profileService: UserService,
    private displayer:DisplayerService
  ) { 
    this.initForm();
    combineLatest([
      this.profileService.getUser(),
      this.countryService.getCountries(),
      this.countryService.getCountriesByCode(),
      this.addressService.getAddressObs()
    ]).subscribe( ([profile, countries, countriesByCode, address]) => {
      if( profile && countries && countriesByCode ){
        this.profile = profile;  
        this.countries = countries;
        this.mapCountries = countriesByCode;
        if( address ){
          this.address = address;
          this.addressForm.controls.street.setValue(address.street);
          this.addressForm.controls.compagny.setValue(address.compagny);
          this.addressForm.controls.complement.setValue(address.additional);
          this.addressForm.controls.building.setValue(address.building);
          this.addressForm.controls.floor.setValue(address.floor);
          this.addressForm.controls.codePostal.setValue(address.codePostal);
          this.addressForm.controls.city.setValue(address.city);
          this.addressForm.controls.country.setValue(this.mapCountries.get(address.country).code);
        }
      }
    });
  }

  ngOnInit() {
    
  }

  initForm() {
    this.addressForm = this.formBuilder.group({
      street: ['', Validators.required],
      additional: [''],
      compagny: [''],
      complement: [''],
      building: [''],
      floor: [''],
      codePostal: ['', Validators.required],
      city: ['',Validators.required], 
      country: ['', Validators.required],
    }
    );  
  }

  async onSubmitForm(){
    if(this.profile)
    this.address =  {
      id: '',
      uid: this.profile.uid,
      street: this.addressForm.value.street,
      floor: this.addressForm.value.floor,
      phone: (this.profile.mobile)?this.profile.mobile:this.profile.phone,
      additional: this.addressForm.value.additional,
      building: this.addressForm.value.building,
      compagny: this.addressForm.value.compagny,
      codePostal: this.addressForm.value.codePostal,
      city: this.addressForm.value.city,
      country: this.addressForm.value.country
    }
    
    this.addressService.setAddress(this.address,this.address).then(address=>{
      if(address){
        this.displayer.presentAlert("Enregistrement réussi","","Votre adresse a bien été mise à jour.");
      }
      else
      this.displayer.presentAlert("Enregistrement échoué","","Un problème est survenu lors de la mise à jour de votre adresse.");
    });
  }

  trackCountry(index:number,country:Country){
    return country.code;
  }
  
  sort(){
    this.descending = !this.descending;
    this.order = this.descending ? 1 : -1;
  }

}
